import { getField, updateField } from 'vuex-map-fields'
import getPayrollFiltersModel, { getAppliedPayrollFiltersModel } from './models/payrollReportFilters'
import buildInitialState from '@/store/helpers/buildInitialState'
import { ALL_BUSINESS_ENTITIES } from '@/lib/constants/businessEntities'

const buildClearedAppliedFilters = () => ({ ...getAppliedPayrollFiltersModel(), businessEntityId: ALL_BUSINESS_ENTITIES })

const payrollReportFilters = {
  namespaced: true,
  state: buildInitialState({
    ...getPayrollFiltersModel(),
    // The filters the report on screen was actually searched with. The fields above are the
    // inputs; only a search copies them down here.
    appliedFilters: getAppliedPayrollFiltersModel()
  }),
  getters: {
    getField,
    pendingFilters: (state) => {
      const { payFrequencyId, dateBegin, dateEnd, businessEntityId, clientId, showDetails, useCustomRange } = state

      return { payFrequencyId, dateBegin, dateEnd, businessEntityId, clientId, showDetails, useCustomRange }
    },
    getSearchObject: (state) => {
      const { payFrequencyId, dateBegin, dateEnd, businessEntityId } = state.appliedFilters

      return { payFrequencyId, dateBegin, dateEnd, businessEntityId }
    }
  },
  mutations: {
    updateField,
    clearFilters: (state) => {
      state.payFrequencyId = null
      state.dateBegin = null
      state.dateEnd = null
      state.businessEntityId = ALL_BUSINESS_ENTITIES
      state.clientId = null
      state.showDetails = true
      state.useCustomRange = false
      // Cleared inputs describe no search, so the applied set has to say the same thing rather
      // than leaving a stale one behind for the rows and the header to read.
      state.appliedFilters = buildClearedAppliedFilters()
    },
    setAppliedFilters: (state, appliedFilters) => {
      state.appliedFilters = appliedFilters
    }
  },
  actions: {
    clearPayrollReportFilters: ({ commit }) => {
      return commit('clearFilters')
    },
    applyPayrollReportFilters: ({ commit }, appliedFilters) => {
      return commit('setAppliedFilters', appliedFilters)
    }
  }
}

export default payrollReportFilters
